export const croppText = () => {
    const croppedText = document.querySelectorAll(".cropped-text");
    croppedText.forEach(
        (text) => (text.textContent = text.textContent.slice(0, 100) + "...")
    );
};
